// extracted by mini-css-extract-plugin
module.exports = {"body":"Callout_body__KhpIJ"};